<template>
  <section>
    <b-modal
      id="digital-signature"
      ref="digital-signature"
      :title="$t('message.deepSign.modal.title')"
      hide-footer
      no-close-on-backdrop
      @hide="hide()">
      <div
        v-if="loading"
        class="row">
        <div class="col text-center">
          <coozzy-spinner class="m-3" />
        </div>
      </div>
      <div
        v-else
        class="row">
        <div
          :key="'signature'"
          class="col-sm-12 col-md-6 mb-2">
          <a
            :href="getLinkSignature"
            class="link"
            target="_blank">
            <h5>
              {{ $t('message.deepSign.modal.signature') }}
            </h5>
          </a>
          <coozzy-form-select
            v-if="!readOnly"
            v-model="signatureInvitation.signType"
            :disabled="readOnly"
            class="select-entries"
            name="listSignatures">
            <option
              v-for="(option, indexSign) in legalWeightOptions"
              :key="indexSign"
              :value="option">
              {{ $t('message.deepSign.modal.options.' + option) }}
            </option>
          </coozzy-form-select>
          <span
            v-else
            class="d-block">
            <span v-if="signatureInvitation.signType === 'LEGAL_WEIGHT_STANDARD'">
              {{ $t('message.deepSign.modal.options.LEGAL_WEIGHT_STANDARD') }}
            </span>
            <span v-else-if="signatureInvitation.signType === 'LEGAL_WEIGHT_PROFESSIONAL'">
              {{ $t('message.deepSign.modal.options.LEGAL_WEIGHT_PROFESSIONAL') }}
            </span>
            <span v-else-if="signatureInvitation.signType === 'LEGAL_WEIGHT_QUALIFIED'">
              {{ $t('message.deepSign.modal.options.LEGAL_WEIGHT_QUALIFIED') }}
            </span>
          </span>
        </div>
        <!-- LandLord Part -->
        <div class="col-12 mb-2">
          <div class="row">
            <h5
              :class="readOnly ? 'col-12' : 'col-8'">
              {{ $t('message.deepSign.modal.landlord') }}
            </h5>
            <div
              v-if="!readOnly"
              :class="readOnly ? '' : 'col-4'">
              <coozzy-button
                class="mb-0 border float-right min-width-btns"
                design="transparent"
                size="small"
                @click="addLandLord()">
                {{ $t('message.deepSign.modal.addLandlord') }}
              </coozzy-button>
            </div>
            <div
              v-for="index in signatureInvitation.landlord.length"
              :key="'landlord_' + index"
              class="col-12 px-0">
              <div class="row mx-0">
                <div class="col-sm-12 col-md-6 mb-2">
                  <label>{{ $t('message.deepSign.modal.landlord') }}<span v-if="!readOnly && index === 1">*</span></label>
                  <coozzy-form-select
                    v-if="!readOnly"
                    v-model="signatureInvitation.landlord[index - 1].userId"
                    :disabled="readOnly"
                    class="select-entries float-right"
                    name="listUsers"
                    @change="userChanged(index - 1)">
                    <option
                      v-for="(emp, indexEmp) in listEmployee"
                      :key="indexEmp"
                      :value="emp.id">
                      {{ emp.profile.lastName }} {{ emp.profile.firstName }}
                    </option>
                  </coozzy-form-select>
                  <span
                    v-else
                    class="d-block">
                    {{ getContactName(signatureInvitation.landlord[index - 1].contactId) }}
                  </span>
                </div>
                <div class="col-sm-12 col-md-6 mb-2">
                  <label>{{ $t('message.generic.email') }}<span v-if="!readOnly && index === 1">*</span></label>
                  <div :class="!readOnly ? 'containerDeleteICon row' : ''">
                    <coozzy-form-input
                      v-model="signatureInvitation.landlord[index - 1].email"
                      :class="!readOnly ? 'col pr-0 adjustWidthInput' : ''"
                      :disabled="true"
                      :is-read-only="readOnly"
                      :placeholder="$t('message.generic.email')"
                      :state="emailInputState(signatureInvitation.landlord[index - 1].email, !readOnly && index === 1)" />
                    <coozzy-button
                      v-if="!readOnly && index > 1"
                      class="deleteBtn col ml-1"
                      @click="deleteLandLord(index - 1)">
                      <coozzy-delete-icon
                        class="deleteIcon" />
                    </coozzy-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Tenants Part -->
        <div
          v-if="signatureInvitation.tenant.length > 0"
          class="col-12 mb-2">
          <div
            v-for="(signTenant, index) in signatureInvitation.tenant"
            :key="'list-tenants-' + index"
            class="row">
            <h5
              v-if="index === 0"
              :class="!readOnly && signTenant.hasContactPersons ? 'col-8' : 'col-12'">
              {{ $t('message.deepSign.modal.tenant') }}
            </h5>
            <div
              v-if="!readOnly && signTenant.hasContactPersons"
              :class="readOnly ? '' : index === 0 ? 'col-4' : 'col-12'">
              <coozzy-button
                class="mb-0 border float-right min-width-btns"
                design="transparent"
                size="small"
                @click="addContactPerson(signTenant.contactId, 'tenant')">
                {{ $t('message.generic.addContactPerson') }}
              </coozzy-button>
            </div>
            <div
              v-for="(signer, indexSigner) in signTenant.signers"
              :key="'tenant_' + indexSigner"
              class="col-12 px-0">
              <div class="row mx-0">
                <div
                  class="col-sm-12 mb-2"
                  :class="signTenant.hasContactPersons ? 'col-md-4' : 'col-md-6'">
                  <label>{{ $t('message.deepSign.modal.tenant') }}<span v-if="!readOnly && indexSigner === 0">*</span></label>
                  <coozzy-form-select
                    v-if="!readOnly"
                    v-model="signTenant.contactId"
                    class="select-entries float-right"
                    name="listUsers"
                    :disabled="true"
                    @change="tenantChanged(index - 1)">
                    <option
                      v-for="(tenant, tenantIndex) in listTenants"
                      :key="tenantIndex"
                      :value="tenant.id">
                      {{ tenant.name }}
                    </option>
                  </coozzy-form-select>
                  <span
                    v-else
                    class="d-block">
                    {{ getContactName(signTenant.contactId) }}
                  </span>
                </div>
                <div
                  v-if="signTenant.hasContactPersons"
                  class="col-sm-12 col-md-4 mb-2">
                  <label>{{ $t('message.tableColumnHeadings.contactPersons') }}</label>
                  <coozzy-form-select
                    v-if="!readOnly"
                    v-model="signer.selectedContact"
                    :disabled="readOnly"
                    class="select-entries float-right"
                    name="listUsers"
                    @change="tenantChanged(index, indexSigner, signer.selectedContact)">
                    <option
                      :value="signTenant.contactId">
                      {{ '-' }}
                    </option>
                    <option
                      v-for="(cp, cpIndex) in signTenant.contactPersons"
                      :key="cpIndex"
                      :value="cp.contactId">
                      {{ cp.name }}
                    </option>
                  </coozzy-form-select>
                  <span
                    v-else
                    class="d-block">
                    {{ getContactName(signer.selectedContact) }}
                  </span>
                </div>
                <div
                  class="col-sm-12 mb-2"
                  :class="signTenant.hasContactPersons ? 'col-md-4' : 'col-md-6'">
                  <label>{{ $t('message.generic.email') }}<span v-if="!readOnly && indexSigner === 0">*</span></label>
                  <div :class="!readOnly ? 'containerDeleteICon row' : ''">
                    <coozzy-form-input
                      v-model="signer.email"
                      :disabled="readOnly"
                      :is-read-only="readOnly"
                      :class="!readOnly ? 'col pr-0 adjustWidthInput' : ''"
                      :placeholder="$t('message.generic.email')"
                      :state="emailInputState(signer.email, !readOnly && indexSigner === 0)"
                      @blur="hasDuplicateEmails()" />
                    <coozzy-button
                      v-if="!readOnly && indexSigner > 0"
                      class="deleteBtn col ml-1"
                      :class="'deleteTenant_' + index"
                      @click="deleteTenant(index, indexSigner)">
                      <coozzy-delete-icon
                        class="deleteIcon" />
                    </coozzy-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Contacts Part -->
        <div
          v-if="!tenancy"
          class="col-12 mb-2">
          <div
            v-for="(signContact, index) in signatureInvitation.contacts"
            id="list-contacts"
            :key="'list-contacts' + index"
            class="row">
            <h5
              :class="!readOnly ? 'col-6' : 'col-12'">
              {{ $t('message.generic.contacts') }}
            </h5>
            <div
              v-if="!readOnly"
              :class="readOnly ? '' : 'col-6'">
              <coozzy-button
                class="mb-0 border float-right min-width-btns"
                design="transparent"
                size="small"
                @click="addContact()">
                {{ $t('message.contact.actions.contact') }}
              </coozzy-button>
              <coozzy-button
                v-if="!readOnly && signContact.hasContactPersons"
                class="mb-0 mr-2 border float-right min-width-btns"
                design="transparent"
                size="small"
                @click="addContactPerson(signContact.contactId, 'contact')">
                {{ $t('message.generic.addContactPerson') }}
              </coozzy-button>
            </div>
            <div
              v-for="(signer, indexSigner) in signContact.signers"
              :key="'contact_' + indexSigner"
              class="col-12 px-0">
              <div class="row mx-0">
                <div
                  :id="'contact_' + indexSigner"
                  class="col-sm-12 mb-2"
                  :class="signContact.hasContactPersons ? 'col-md-4' : 'col-md-6'">
                  <label>{{ $t('message.calendar.reminder.contact') }}<span v-if="!readOnly && indexSigner === 0">*</span></label>
                  <contact-search-provider
                    v-if="!readOnly"
                    :filters="contactSearchFilters">
                    <template #default="{ hits, refine }">
                      <vue-autosuggest
                        :ref="'autosuggest_' + indexSigner"
                        v-model="signContact.name"
                        :input-props="{
                          placeholder: $t('message.generic.search'),
                          class: 'custom-select' + (indexSigner === 0 && !signContact.contactId && $v.signatureInvitation.contacts.$error ? ' is-invalid' : ''),
                          id: 'autosuggest__input',
                          disabled: indexSigner > 0
                        }"
                        :suggestions="hitsToSuggestions(hits)"
                        @input="onChange(refine, $event, index)"
                        @selected="onSelect($event, index)">
                        <template #default="{ suggestion }">
                          <div
                            :id="'tooltip-target_' + (suggestion.item.objectID || suggestion.item.id)"
                            :class="checkSelectedElement(suggestion.item.objectID || suggestion.item.id) ? 'selected' : ''">
                            <strong>{{ suggestion.item.name }} {{ suggestion.item.types?.length > 0 ? '-' : '' }} {{
                              suggestion.item.types?.map(obj => $t('message.contact.types.' +
                                obj.toUpperCase())).join(', ')
                            }}</strong>
                            <span v-if="suggestion.item.address"> <br>{{ suggestion.item.address.street }} {{
                              suggestion.item.address.streetNumber
                            }} <span
                              v-if="(suggestion.item.address.streetNumber && suggestion.item.address.streetNumber !== '') || (suggestion.item.address.street && suggestion.item.address.street !== '')">,</span>
                              {{
                                suggestion.item.address.zip
                              }} {{
                                suggestion.item.address.city
                              }}</span>
                          </div>
                          <b-tooltip
                            v-if="checkSelectedElement(suggestion.item.objectID || suggestion.item.id)"
                            :container="'#list-contacts'"
                            :target="'tooltip-target_' + (suggestion.item.objectID || suggestion.item.id)"
                            placement="bottom"
                            triggers="hover">
                            {{ $t('message.savingErrors.contactAlreadySelected') }}
                          </b-tooltip>
                        </template>
                      </vue-autosuggest>
                    </template>
                  </contact-search-provider>
                  <span
                    v-else
                    class="d-block">
                    {{ getContactName(signContact.contactId) }}
                  </span>
                </div>
                <div
                  v-if="signContact.hasContactPersons"
                  class="col-sm-12 col-md-4 mb-2">
                  <label>{{ $t('message.tableColumnHeadings.contactPersons') }}</label>
                  <coozzy-form-select
                    v-if="!readOnly"
                    v-model="signer.selectedContact"
                    :disabled="readOnly"
                    class="select-entries float-right"
                    name="listUsers"
                    @change="contactChanged(index, indexSigner, signer.selectedContact)">
                    <option
                      :value="signContact.contactId">
                      {{ '-' }}
                    </option>
                    <option
                      v-for="(cp, cpIndex) in signContact.contactPersons"
                      :key="cpIndex"
                      :value="cp.contactId">
                      {{ cp.name }}
                    </option>
                  </coozzy-form-select>
                  <span
                    v-else
                    class="d-block">
                    {{ getContactName(signer.selectedContact) }}
                  </span>
                </div>
                <div
                  class="col-sm-12 mb-2"
                  :class="signContact.hasContactPersons ? 'col-md-4' : 'col-md-6'">
                  <label>{{ $t('message.generic.email') }}<span v-if="!readOnly && indexSigner === 0">*</span></label>
                  <div :class="!readOnly ? 'containerDeleteICon row' : ''">
                    <coozzy-form-input
                      v-model="signer.email"
                      :class="!readOnly ? 'col pr-0 adjustWidthInput' : ''"
                      :is-read-only="readOnly"
                      :placeholder="$t('message.generic.email')"
                      :state="emailInputState(signer.email, !readOnly && indexSigner === 0)"
                      @blur="hasDuplicateEmails()" />
                    <coozzy-button
                      v-if="!readOnly && (index > 0 || indexSigner > 0)"
                      class="deleteBtn col ml-1"
                      @click="deleteContact(index, indexSigner)">
                      <coozzy-delete-icon class="deleteIcon" />
                    </coozzy-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Guarantor Part -->
        <div
          v-if="signatureInvitation.guarantor.length > 0"
          class="col-12">
          <div class="row">
            <h5 class="col-12">
              {{ $t('message.deepSign.modal.guarantor') }}
            </h5>
            <div
              v-for="guarantorIndex in signatureInvitation.guarantor.length"
              :key="'guarantor_' + guarantorIndex"
              class="col-12 px-0">
              <div class="row mx-0">
                <div class="col-sm-12 col-md-6 mb-2">
                  <label>{{ $t('message.deepSign.modal.guarantor') }}</label>
                  <coozzy-form-select
                    v-if="!readOnly"
                    v-model="signatureInvitation.guarantor[guarantorIndex - 1].contactId"
                    :disabled="readOnly"
                    class="select-entries float-right"
                    name="listUsers"
                    @change="guarantorChanged(index - 1)">
                    <option
                      v-for="(guarantor, index) in listGuarantors"
                      :key="index"
                      :value="guarantor.id">
                      {{ guarantor.name }}
                    </option>
                  </coozzy-form-select>
                  <span
                    v-else
                    class="d-block">
                    {{ getContactName(signatureInvitation.guarantor[guarantorIndex - 1].contactId) }}
                  </span>
                </div>
                <div
                  :class="!readOnly ? 'pr-0' : ''"
                  class="col-sm-12 col-md-6 mb-2">
                  <label>{{ $t('message.generic.email') }}</label>
                  <div :class="!readOnly ? 'containerDeleteICon' : ''">
                    <coozzy-form-input
                      v-model="signatureInvitation.guarantor[guarantorIndex - 1].email"
                      :disabled="readOnly"
                      :is-read-only="readOnly"
                      :placeholder="$t('message.generic.email')"
                      :state="$v.checkEmails.$dirty && $v.checkEmails.$error && checkEmails.includes(signatureInvitation.guarantor[guarantorIndex - 1].email) ? false : null"
                      @blur="hasDuplicateEmails()" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Message -->
        <div class="col-12">
          <div class="row">
            <h5 class="col-12">
              {{ $t('message.generic.message') }}
            </h5>
            <div
              v-if="!readOnly"
              class="col-sm-12 col-md-12 mb-2">
              <label>{{ $t('message.settings.template.textTemplate') }}</label>
              <coozzy-form-select
                v-model="templateId">
                <option :value="null" />
                <option
                  v-for="template in sortedTemplate"
                  :key="template.id"
                  :value="template">
                  {{ template.name }}
                </option>
              </coozzy-form-select>
            </div>
            <div
              class="col-md-12 mb-2">
              <coozzy-form-textarea
                v-model="signatureInvitation.note"
                :disabled="readOnly"
                :initial="signatureInvitation.note"
                :is-read-only="readOnly"
                :placeholder="$t('message.generic.message')"
                :resizable="false"
                :rows="5"
                :show-label="false"
                :text="signatureInvitation.note"
                :value-text-area="signatureInvitation.note" />
            </div>
          </div>
        </div>
        <!-- Obligatory documents -->
        <div class="col-12">
          <div class="row">
            <h5 class="col-12">
              {{ $t('message.deepSign.modal.signatureObligatoryDocs') }}
            </h5>
            <div
              class="col-md-12 mb-2">
              <div
                class="row">
                <div
                  :key="'docName'"
                  class="col-12">
                  <label>{{ $t('message.manageDocuments.documentName') }}</label>
                  <coozzy-form-input
                    v-model="documentName"
                    :disabled="readOnly"
                    :is-read-only="readOnly"
                    :placeholder="$t('message.manageDocuments.documentName')"
                    :state="$v.documentName.$dirty && $v.documentName.$error ? false : null" />
                </div>
                <div
                  :key="'docType'"
                  class="col-12">
                  <label>{{ $t('message.manageDocuments.type.title') }}</label>
                  <coozzy-form-select
                    v-if="!readOnly"
                    v-model="documentType"
                    :disabled="readOnly"
                    :state="$v.documentType.$dirty && $v.documentType.$error ? false : null"
                    class="select-entries float-right"
                    name="listUsers">
                    <option
                      v-for="(type, j) in documentsType"
                      :key="j"
                      :value="type">
                      {{ $t('message.manageDocuments.type.' + type) }}
                    </option>
                  </coozzy-form-select>
                  <span
                    v-else
                    class="d-block">
                    {{ documentType !== '' ? $t('message.manageDocuments.type.' + documentType) : '-' }}
                  </span>
                </div>
                <div
                  :key="'docFile'"
                  class="col-12 attachment">
                  <label for="attachment"> {{ $t('message.ticketOverview.ticket.attachment') }}</label>
                  <coozzy-form-file-input
                    v-if="!readOnly"
                    :id="'fileInput'"
                    :key="'fileInput'"
                    :ref="'fileInput'"
                    :disabled="uploading"
                    :state="$v.mediasList.$dirty && $v.mediasList.$error ? false : null"
                    accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .doc, .docx, .pdf"
                    multiple
                    @change="addFile($event)" />
                  <div class="row">
                    <div
                      v-for="(media, index) in mediasList"
                      :key="media.id"
                      class="col-12 square">
                      <div
                        class="file-block row">
                        <a
                          :href="media.url"
                          class="link adjustWidthInput col"
                          target="_blank">
                          {{ media.filename }}
                        </a>
                        <coozzy-button
                          v-if="!readOnly"
                          class="deleteBtn col ml-1"
                          @click="deleteDocument(index)">
                          <coozzy-delete-icon
                            class="deleteIcon" />
                        </coozzy-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div
              v-if="!signatureRequest || getStatus() === 'incomplete'"
              class="col mt-3">
              <coozzy-button
                class="mb-0 border"
                design="transparent"
                size="small"
                @click="hide()">
                {{ $t('message.generic.cancel') }}
              </coozzy-button>
              <coozzy-button
                v-if="!readOnly"
                :disabled="uploading"
                class="float-right mb-0"
                design="green"
                size="small"
                @click="submitSendDocument">
                {{ $t('message.generic.create') }}
              </coozzy-button>
              <coozzy-button
                v-else
                :disabled="signatureRequest.cancelled"
                class="float-right mb-0"
                design="green"
                size="small"
                @click="cancelSignature">
                {{ $t('message.deepSign.cancelSignature') }}
              </coozzy-button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="cancelSignatureModal"
      ref="cancelSignatureModal"
      :title="$t('message.generic.confirm')"
      hide-footer
      no-close-on-backdrop
      @hide="hideCancelSignature()">
      <div class="col p-0">
        <p>{{ $t('message.deepSign.messageCancelSignature') }}</p>
      </div>
      <div class="col p-0">
        <coozzy-button
          class="mb-0 border"
          design="transparent"
          size="small"
          @click="hideCancelSignature">
          {{ $t('message.generic.cancel') }}
        </coozzy-button>
        <coozzy-button
          class="float-right mb-0"
          design="green"
          size="small"
          @click="cancelSignatureConfirmation">
          {{ $t('message.generic.confirm') }}
        </coozzy-button>
      </div>
    </b-modal>
  </section>
</template>

<script>

import { user } from '@/mixins/user'
import CoozzyFormSelect from '@/framework/components/form/select/CoozzyFormSelect.vue'
import CoozzyFormTextarea from '@/framework/components/form/textarea/CoozzyFormTextarea.vue'
import Vue from 'vue'
import CoozzyFormInput from '@/framework/components/form/input/CoozzyFormInput.vue'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import CoozzyFormFileInput from '@/framework/components/form/fileInput/CoozzyFormFileInput.vue'
import { media } from '@/mixins/media'
import ContactApi from '@/misc/apis/ContactApi'
import MessageApi from '@/misc/apis/MessageApi'
import { email, maxLength, minLength, required } from 'vuelidate/lib/validators'
import DeepSignApi from '@/misc/apis/DeepSignApi'
import MediaApi from '@/misc/apis/MediaApi'
import CoozzyDeleteIcon from '@/framework/components/icons/CoozzyDeleteIcon.vue'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import ContactSearchProvider from '@/framework/components/search/ContactSearchProvider.vue'
import { mapState } from 'vuex'
import { VueAutosuggest } from 'vue-autosuggest'
import { deepSign } from '@/mixins/deepSign'
import { isAxiosError } from 'axios'

export default {
  name: 'DigitalSignatureModal',
  components: {
    CoozzySpinner,
    CoozzyDeleteIcon,
    CoozzyFormFileInput,
    CoozzyButton,
    CoozzyFormInput,
    CoozzyFormTextarea,
    CoozzyFormSelect,
    VueAutosuggest,
    ContactSearchProvider
  },
  mixins: [user, media, deepSign],
  props: {
    requestId: {
      type: String,
      default: ''
    },
    tenancy: {
      type: Object,
      default: null
    },
    contacts: {
      type: Array,
      required: true,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    signatureRequest: {
      type: Object,
      default: null
    },
    objectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      templateId: null,
      signatureInvitation: {
        signType: 'LEGAL_WEIGHT_STANDARD',
        landlord: [],
        tenant: [],
        contacts: [],
        guarantor: [],
        note: ''
      },
      legalWeightOptions: ['LEGAL_WEIGHT_STANDARD', 'LEGAL_WEIGHT_PROFESSIONAL', 'LEGAL_WEIGHT_QUALIFIED'],
      documentName: '',
      documentType: 'contract',
      documentsType: ['handover_protocol', 'maintenance_contract_doc_type', 'regulations', 'regulations_for_use_and_management', 'other', 'contract', 'agreement', 'key_list', 'letter'],
      uploading: false,
      loading: false,
      attachment: [],
      mediasList: [],
      templateAddedMediaIds: [],
      listContacts: [],
      checkEmails: [],
      searchedContacts: [],
      listTenantsGrouped: []
    }
  },
  computed: {
    ...mapState('message', ['templates']),
    listEmployee() {
      return this.$store.getters['employee/getEmployees'].filter(
        e => !e.deleted && !e.blocked && (e.roles.includes('digital_signature') || e.roles.includes('company_admin'))
      )
    },
    listTenants() {
      if (this.tenancy !== null && this.listContacts.length > 0) {
        const contactIds = this.tenancy.tenant?.contactIds
        return this.listContacts.filter(c => contactIds.includes(c.id))
      }
      return []
    },
    listGuarantors() {
      if (this.tenancy !== null && this.listContacts.length > 0) {
        const contactIds = this.tenancy.tenant?.guarantorContactIds
        return this.listContacts.filter(c => contactIds.includes(c.id))
      }
      return []
    },
    getLinkSignature() {
      let link = ''
      if (this.currentLanguage === 'en') {
        link = 'https://www.deepsign.swiss/en/electronic-signature/'
      } else if (this.currentLanguage === 'de') {
        link = 'https://www.deepsign.swiss/de/elektronische-signatur/'
      } else if (this.currentLanguage === 'it') {
        link = 'https://www.deepsign.swiss/it/firma-elettronica/'
      }
      return link
    },
    contactSearchFilters() {
      const filters = { active: true }
      if (this.ownerId && this.accountId) {
        filters.ownerIds = [String(this.ownerId), String(this.accountId)]
      }
      return filters
    },
    sortedTemplate() {
      return this.templates.filter(x => x.type === 'TEMPLATE_TYPE_DEEP_SIGN').slice().sort((a, b) => {
        if (a.name > b.name) {
          return 1
        }
        if (b.name > a.name) {
          return -1
        }
        return 0
      })
    }
  },
  watch: {
    templateId: function (val) {
      if (val !== null) {
        this.renderTemplate()
      } else {
        this.signatureInvitation.note = ''
        this.removeTemplateAddedMedia()
      }
    }
  },
  mounted() {
    this.listContacts = this.contacts
    if (this.tenancy?.tenant?.contactIds?.length > 0) {
      this.tenancy?.tenant?.contactIds.forEach(id => {
        const contact = this.listContacts.find(c => c.id === id) || null
        if (contact) {
          if (this.signatureRequest) {
            const isTenancyRequest = this.signatureRequest.attachToReferenceIds.filter(x => x.startsWith('tenancy')).length > 0
            if (isTenancyRequest) {
              this.signatureRequest.signers.forEach(signer => {
                const signContact = this.listContacts.find(c => c.id === signer.contactId || ('contactPersons' in c && c.contactPersons.some(cp => cp.id === signer.contactId)))
                if (signContact && signer.order === 1 && signContact.id === signer.contactId) {
                  // check if contact is already in the tenant
                  const tenantIndex = this.signatureInvitation.tenant.findIndex(x => x.contactId === signer.contactId)
                  if (tenantIndex === -1) {
                    this.signatureInvitation.tenant.push({
                      contactId: signer.contactId,
                      email: signContact?.email || '',
                      name: signContact?.name || '',
                      hasContactPersons: false,
                      signers: [{ contactId: signContact.id, name: signContact.name, email: signContact.email, selectedContact: signContact.id }]
                    })
                  }
                } else if (signContact && signer.order === 1 && 'contactPersons' in signContact && signContact.contactPersons.some(cp => cp.id === signer.contactId)) {
                  const contactPerson = signContact.contactPersons.find(cp => cp.id === signer.contactId)
                  const tenantIndex = this.signatureInvitation.tenant.findIndex(x => x.contactId === signContact.id)
                  if (tenantIndex !== -1) {
                    const indexSigner = this.signatureInvitation.tenant.findIndex(x => x.signers.some(s => s.contactId === contactPerson.id))
                    if (indexSigner === -1) {
                      this.signatureInvitation.tenant[tenantIndex].signers.push({
                        contactId: contactPerson.id,
                        name: contactPerson.name,
                        email: contactPerson.email,
                        selectedContact: contactPerson.id
                      })
                    }
                  } else {
                    this.signatureInvitation.tenant.push({
                      contactId: signContact.id,
                      email: contactPerson?.email || '',
                      name: signContact?.name || '',
                      hasContactPersons: true,
                      signers: [{
                        contactId: contactPerson.id,
                        name: contactPerson.name,
                        email: contactPerson.email,
                        selectedContact: contactPerson.id
                      }]
                    })
                  }
                }
              })
            }
          } else {
            const contactHasContactPersons = 'contactPersons' in contact && contact.contactPersons.filter(x => x.active === true).length > 0
            this.signatureInvitation.tenant.push({
              contactId: id,
              email: contact.email || '',
              name: contact.name || '',
              hasContactPersons: contactHasContactPersons,
              contactPersons: contactHasContactPersons ? contact.contactPersons.filter(x => x.active === true).map(cp => ({ email: cp.email, contactId: cp.id, name: cp.name })) : [],
              signers: [{ contactId: id, email: contact.email, name: contact.name, selectedContact: id }]
            })
          }
        }
      })
    } else if (!this.tenancy && !this.signatureRequest) {
      this.signatureInvitation.contacts.push({
        contactId: '',
        email: '',
        name: '',
        hasContactPersons: false,
        contactPersons: [],
        signers: [{ contactId: '', email: '', name: '', selectedContact: '' }]
      })
    }
    if (this.tenancy?.tenant?.guarantorContactIds?.length > 0) {
      this.tenancy?.tenant?.guarantorContactIds.forEach(id => {
        this.signatureInvitation.guarantor.push({
          contactId: id,
          email: this.listContacts.find(c => c.id === id)?.email || ''
        })
      })
    }
    if (this.signatureRequest) {
      this.signatureInvitation.note = this.signatureRequest.note
      this.signatureInvitation.signType = this.signatureRequest.legalWeight
      this.documentName = this.signatureRequest.name
      this.documentType = this.signatureRequest.documentType?.toLocaleLowerCase()
      if (this.signatureRequest.mediaIds.length > 0 || this.signatureRequest.signedMediaId !== '') {
        const mediaIds = this.signatureRequest.signedMediaId !== '' ? [this.signatureRequest.signedMediaId] : this.signatureRequest.mediaIds
        if (mediaIds.length > 0) {
          this.loading = true
          MediaApi.getListMedia(mediaIds).then(response => {
            for (const media of response.media) {
              this.mediasList.push(media)
            }
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      }
      if (this.signatureRequest.signers.length > 0) {
        const isContactRequest = this.signatureRequest.attachToReferenceIds.filter(x => x.startsWith('contact')).length > 0
        this.signatureRequest.signers.forEach(signer => {
          const contact = this.listContacts.find(c => c.id === signer.contactId || ('contactPersons' in c && c.contactPersons.some(cp => cp.id === signer.contactId)))
          if (contact) {
            if (signer.order === 1 && isContactRequest) {
              if (contact.id === signer.contactId) {
                this.signatureInvitation.contacts.push({
                  contactId: contact.id,
                  email: contact.email,
                  name: contact.name,
                  hasContactPersons: false,
                  signers: [{ contactId: contact.id, name: contact.name, email: contact.email, selectedContact: contact.id }]
                })
              } else if ('contactPersons' in contact && contact.contactPersons.some(cp => cp.id === signer.contactId)) {
                const contactPerson = contact.contactPersons.find(cp => cp.id === signer.contactId)
                const tenantIndex = this.signatureInvitation.contacts.findIndex(x => x.contactId === contact.id)
                if (tenantIndex !== -1) {
                  const indexSigner = this.signatureInvitation.contacts.findIndex(x => x.signers.some(s => s.contactId === contactPerson.id))
                  if (indexSigner === -1) {
                    this.signatureInvitation.contacts[tenantIndex].signers.push({
                      contactId: contactPerson.id,
                      name: contactPerson.name,
                      email: contactPerson.email,
                      selectedContact: contactPerson.id
                    })
                  }
                } else {
                  this.signatureInvitation.contacts.push({
                    contactId: contact.id,
                    email: contactPerson?.email || '',
                    name: contact?.name || '',
                    hasContactPersons: true,
                    signers: [{
                      contactId: contactPerson.id,
                      name: contactPerson.name,
                      email: contactPerson.email,
                      selectedContact: contactPerson.id
                    }]
                  })
                }
              }
            } else if (signer.order === 2) {
              this.signatureInvitation.landlord.push({
                contactId: contact.id,
                email: contact.email,
                name: contact.name
              })
            }
          }
        })
      }
    } else {
      this.addLandLord()
      this.signatureInvitation.landlord[0].userId = this.userId
      this.signatureInvitation.landlord[0].email = this.userEmail
      if (this.listEmployee.length > 0) {
        const currentUser = this.listEmployee.find(e => e.id === this.userId)
        if (currentUser && currentUser.profile && currentUser.profile.signatureAuthorization === 'SIGNATURE_AUTHORIZATION_COLLECTIVELY_BY_TWO') {
          this.addLandLord()
        }
      }
    }
    this.$nextTick(() => {
      this.hasDuplicateEmails()
    })
  },
  methods: {
    removeTemplateAddedMedia() {
      if (!this.templateAddedMediaIds.length) {
        return
      }
      const ids = new Set(this.templateAddedMediaIds)
      this.mediasList = this.mediasList.filter(m => !ids.has(m.id))
      this.templateAddedMediaIds = []
    },
    renderTemplate(objectId = '') {
      this.removeTemplateAddedMedia()
      const selectedTemplateId = this.templateId?.id
      if (!selectedTemplateId) {
        return
      }
      const currentObjectId = objectId !== '' ? objectId : ''
      MessageApi.renderTemplate(selectedTemplateId, '', currentObjectId)
        .then(response => {
          if (this.templateId?.id !== selectedTemplateId) {
            return
          }
          this.signatureInvitation.note = response.text

          const template = this.templates.find(element => element.id === selectedTemplateId)
          if (!template?.attachmentMediaIds?.length) {
            return
          }
          const promises = template.attachmentMediaIds.map(mediaId => MediaApi.getMediaByID(mediaId))

          Promise.all(promises)
            .then((response) => {
              if (this.templateId?.id !== selectedTemplateId) {
                return
              }
              for (const { media } of response) {
                if (this.mediasList.some(m => m.id === media.id)) {
                  continue
                }
                this.mediasList.push(media)
                this.templateAddedMediaIds.push(media.id)
              }
            })
            .catch(e => {
              if (this.templateId?.id !== selectedTemplateId) {
                return
              }
              console.log(e)
              Vue.toasted.show(this.$t('message.loadingErrors.media'), { type: 'error' })
            })
        })
        .catch(e => {
          if (this.templateId?.id !== selectedTemplateId) {
            return
          }
          console.log(e)
          Vue.toasted.show(this.$t('message.loadingErrors.renderTemplate'), { type: 'error' })
        })
    },
    checkSelectedElement(id) {
      if (id) {
        if (this.signatureInvitation.contacts.find(x => x.contactId === id)) {
          return true
        }
      }
      return false
    },
    getStatus() {
      if (this.signatureRequest) {
        if (this.signatureRequest.cancelled) {
          return 'cancelled'
        } else if (this.signatureRequest.signers.every((x) => x.signed) || this.signatureRequest.completed) {
          return 'complete'
        } else if (this.signatureRequest.signers.some(signer => !signer.signed)) {
          return 'incomplete'
        }
      }
      return ''
    },
    onChange(refine, name) {
      refine(name)
    },
    onSelect(selected, index) {
      if (!selected?.item) {
        return
      }
      if (!this.checkSelectedElement(selected.item.objectID || selected.item.id)) {
        this.signatureInvitation.contacts[index].name = selected.item.name
        this.signatureInvitation.contacts[index].contactId = selected.item.objectID || selected.item.id
        this.signatureInvitation.contacts[index].email = selected.item.email
        if ('contactPersons' in selected.item && selected.item.contactPersons.filter(x => x.active === true).length > 0) {
          this.signatureInvitation.contacts[index].hasContactPersons = true
          this.signatureInvitation.contacts[index].contactPersons = selected.item.contactPersons.filter(x => x.active === true).map(cp => ({ email: cp.email, contactId: cp.id, name: cp.name }))
          this.signatureInvitation.contacts[index].signers = [{ contactId: selected.item.objectID || selected.item.id, email: selected.item.email, name: selected.item.name, selectedContact: selected.item.objectID || selected.item.id }]
        } else {
          this.signatureInvitation.contacts[index].hasContactPersons = false
          this.signatureInvitation.contacts[index].contactPersons = []
          this.signatureInvitation.contacts[index].signers = [{ contactId: selected.item.objectID || selected.item.id, email: selected.item.email, name: selected.item.name, selectedContact: selected.item.objectID || selected.item.id }]
        }
        if (!this.listContacts.find(x => x.id === selected.item.objectID || x.id === selected.item.id)) {
          if (selected.item.objectID) {
            selected.item.id = selected.item.objectID
          }
          this.listContacts.push(selected.item)
        }
        this.hasDuplicateEmails()
      } else {
        if ((this.$refs['autosuggest_' + (index + 1)]?.length || 0) > 0) {
          this.$refs['autosuggest_' + (index + 1)][0].internalValue = ''
        }
        this.signatureInvitation.contacts[index].contactId = ''
        this.signatureInvitation.contacts[index].email = ''
        this.signatureInvitation.contacts[index].name = ''
      }
    },
    hitsToSuggestions(hits) {
      return [{
        data: hits.filter(hit => {
          return hit.active
        }).concat(hits.flatMap(hit => {
          if ('contactPersons' in hit && hit.contactPersons.length > 0) {
            return hit.contactPersons.filter(cp => cp.active).map(cp => {
              const obj = JSON.parse(JSON.stringify(hit))
              delete obj.contactPersons
              cp.company = obj
              return cp
            })
          } else {
            return []
          }
        }))
      }]
    },
    contactChanged(indexContact, indexSigner, contactId) {
      let contact = null
      this.listContacts.forEach(c => {
        if (c.id === contactId) {
          contact = c
        } else if ('contactPersons' in c && c.contactPersons.length > 0) {
          c.contactPersons.forEach(cp => {
            if (cp.id === contactId) {
              contact = cp
            }
          })
        }
      })
      if (contact === null) {
        return
      }
      if (this.signatureInvitation.contacts[indexContact].contactId === contactId) {
        this.signatureInvitation.contacts[indexContact].signers[indexSigner].email = this.signatureInvitation.contacts[indexContact].email
        this.signatureInvitation.contacts[indexContact].signers[indexSigner].name = this.signatureInvitation.contacts[indexContact].name
        this.signatureInvitation.contacts[indexContact].signers[indexSigner].contactId = this.signatureInvitation.contacts[indexContact].contactId
        this.signatureInvitation.contacts[indexContact].signers[indexSigner].selectedContact = contactId
        this.hasDuplicateEmails()
        return
      }
      if (this.signatureInvitation.contacts[indexContact] && this.signatureInvitation.contacts[indexContact].signers[indexSigner]) {
        this.signatureInvitation.contacts[indexContact].signers[indexSigner].email = contact.email
        this.signatureInvitation.contacts[indexContact].signers[indexSigner].name = contact.name
        this.signatureInvitation.contacts[indexContact].signers[indexSigner].contactId = contact.id
        this.hasDuplicateEmails()
      }
    },
    getLandLordName(userId) {
      const emp = this.listEmployee.find(e => e.id === userId)
      if (emp) {
        return emp.profile.firstName + ' ' + emp.profile.lastName
      }
      return '-'
    },
    getContactName(contactId) {
      let contact = null
      this.contacts.forEach(c => {
        if (c.id === contactId) {
          contact = c
        } else if ('contactPersons' in c && c.contactPersons.length > 0) {
          c.contactPersons.forEach(cp => {
            if (cp.id === contactId) {
              contact = cp
            }
          })
        }
      })
      if (contact) {
        return contact.name
      }
      return '-'
    },
    hide() {
      this.$refs['digital-signature']?.hide()
      this.$emit('hide')
    },
    show() {
      this.$refs['digital-signature']?.show()
    },
    async addFile(event) {
      let hasError = false
      const docType = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
      const files = await this.getFilesFromEvent(event)
      if (files && files.length > 0) {
        for (let index = 0; index < files.length; index++) {
          const element = files[index]
          if (docType.includes(element.type) && element.size > 0) {
            this.attachment.push(element)
          } else {
            hasError = true
          }
        }
      }
      if (this.attachment.length > 0) {
        this.sendFile()
      }
      this.$nextTick(() => {
        if (hasError) {
          Vue.toasted.show(this.$tc('message.deepSign.modal.warningDocType'), { type: 'error' })
        }
        if (this.$refs.fileInput) {
          this.$refs.fileInput.resetPlaceholder()
        }
      })
    },
    async sendFile() {
      this.uploading = true
      const response = await this.uploadMedia(this.attachment, this.accountId, false)
      if (response?.length > 0) {
        for (const media of response) {
          this.mediasList.push(media)
        }
        this.$nextTick(() => {
          this.attachment = []
          this.uploading = false
        })
      } else {
        this.uploading = false
      }
    },
    addContactPerson(id, src) {
      const contact = this.listContacts.find(c => c.id === id) || null
      if (contact) {
        if (src === 'tenant') {
          const index = this.signatureInvitation.tenant.findIndex(x => x.contactId === id)
          if (index !== -1) {
            this.signatureInvitation.tenant[index].signers.push({ contactId: contact.id, name: '', email: contact.email, selectedContact: contact.id })
          }
        } else if (src === 'contact') {
          const index = this.signatureInvitation.contacts.findIndex(x => x.contactId === id)
          if (index !== -1) {
            this.signatureInvitation.contacts[index].signers.push({ contactId: contact.id, name: '', email: contact.email, selectedContact: contact.id })
          }
        }
      }
    },
    addLandLord() {
      this.signatureInvitation.landlord.push({
        userId: '',
        email: ''
      })
    },
    addContact() {
      this.signatureInvitation.contacts.push({
        contactId: '',
        email: '',
        name: '',
        hasContactPersons: false,
        contactPersons: [],
        signers: [{ contactId: '', email: '', name: '', selectedContact: '' }]
      })
    },
    userChanged(index) {
      const userId = this.signatureInvitation.landlord[index].userId
      this.signatureInvitation.landlord[index].email = this.listEmployee.find(e => e.id === userId).email
      this.hasDuplicateEmails()
    },
    tenantChanged(indexTenant, indexSigner, contactId) {
      let contact = null
      this.listContacts.forEach(c => {
        if (c.id === contactId) {
          contact = c
        } else if ('contactPersons' in c && c.contactPersons.length > 0) {
          c.contactPersons.forEach(cp => {
            if (cp.id === contactId) {
              contact = cp
            }
          })
        }
      })
      if (contact === null) {
        return
      }
      if (this.signatureInvitation.tenant[indexTenant].contactId === contactId) {
        this.signatureInvitation.tenant[indexTenant].signers[indexSigner].email = this.signatureInvitation.tenant[indexTenant].email
        this.signatureInvitation.tenant[indexTenant].signers[indexSigner].name = this.signatureInvitation.tenant[indexTenant].name
        this.signatureInvitation.tenant[indexTenant].signers[indexSigner].contactId = this.signatureInvitation.tenant[indexTenant].contactId
        this.signatureInvitation.tenant[indexTenant].signers[indexSigner].selectedContact = contactId
        this.hasDuplicateEmails()
        return
      }
      if (this.signatureInvitation.tenant[indexTenant] && this.signatureInvitation.tenant[indexTenant].signers[indexSigner]) {
        this.signatureInvitation.tenant[indexTenant].signers[indexSigner].email = contact.email
        this.signatureInvitation.tenant[indexTenant].signers[indexSigner].name = contact.name
        this.signatureInvitation.tenant[indexTenant].signers[indexSigner].contactId = contact.id
        this.hasDuplicateEmails()
      }
    },
    guarantorChanged(index) {
      const contactId = this.signatureInvitation.guarantor[index].contactId
      this.signatureInvitation.guarantor[index].email = this.contacts.find(e => e.id === contactId).email
      this.hasDuplicateEmails()
    },

    deleteDocument(index) {
      this.mediasList.splice(index, 1)
    },
    deleteLandLord(index) {
      this.signatureInvitation.landlord.splice(index, 1)
    },
    deleteTenant(indexTenant, indexSigner) {
      this.signatureInvitation.tenant[indexTenant].signers.splice(indexSigner, 1)
      if (this.signatureInvitation.tenant[indexTenant].signers.length === 0) {
        this.signatureInvitation.tenant.splice(indexTenant, 1)
      }
    },
    deleteContact(indexContact, indexSigner) {
      this.signatureInvitation.contacts[indexContact].signers.splice(indexSigner, 1)
      if (this.signatureInvitation.contacts[indexContact].signers.length === 0) {
        this.signatureInvitation.contacts.splice(indexContact, 1)
      }
    },
    updateContact(contact, email) {
      contact.email = email
      contact.gender = contact.gender?.toUpperCase()
      if (contact.types?.length) {
        contact.types = contact.types.map(type => type.toUpperCase())
      }
      // check if contact is a contactPerson
      const companyContact = this.listContacts.find(x => x.id === contact.id)
      if (contact.company) {
        ContactApi.editContactPerson(contact, contact.company.objectID || contact.company.id, contact.id).catch(e => {
          console.log(e)
          Vue.toasted.show(this.$tc('message.savingErrors.editContact'), { type: 'error' })
        })
      } else {
        ContactApi.editContact(contact).then(response => {
          const data = { contact: null }
          if (response.person) {
            data.contact = response.person
          } else if (response.company) {
            data.contact = response.company
          }
          this.$emit('contact-updated', data)
        })
          .catch(e => {
            console.log(e)
            Vue.toasted.show(this.$tc('message.savingErrors.editContact'), { type: 'error' })
          })
      }
    },
    submitSendDocument() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        if (this.$v.checkEmails.$dirty && this.$v.checkEmails.$error) {
          Vue.toasted.show(this.$tc('message.savingErrors.signersHasSameEmails'), { type: 'error' })
        }
        if (!this.tenancy && this.$v.signatureInvitation.contacts.$error) {
          Vue.toasted.show(this.$tc('message.savingErrors.contactRequired'), { type: 'error' })
        }
        if (this.$v.mandatorySignerEmails.$error) {
          Vue.toasted.show(this.$tc('message.savingErrors.mandatoryMissing'), { type: 'error' })
        }
      }
      if (!this.$v.$invalid) {
        if (this.uploading || this.loading) {
          return
        }
        this.uploading = true
        this.loading = true
        // check if tenant email updated
        if (this.signatureInvitation.tenant.length > 0) {
          this.signatureInvitation.tenant.forEach(tenant => {
            if (tenant.signers.length > 0) {
              tenant.signers.forEach(signer => {
                if (signer.contactId) {
                  const contact = this.listContacts.find(e => e.id === signer.contactId || ('contactPersons' in e && e.contactPersons.some(cp => cp.id === signer.contactId)))
                  if (contact.id === signer.contactId) {
                    if (signer.email !== contact.email) {
                      this.updateContact(contact, signer.email)
                    }
                  } else if ('contactPersons' in contact && contact.contactPersons.some(cp => cp.id === signer.contactId)) {
                    const contactPerson = contact.contactPersons.find(cp => cp.id === signer.contactId)
                    if (signer.email !== contactPerson.email) {
                      this.updateContact({ ...contactPerson, company: { id: contact.id, name: contact.name } }, signer.email)
                    }
                  }
                }
              })
            }
          })
        }
        // check if Contact email updated
        if (this.signatureInvitation.contacts.length > 0) {
          this.signatureInvitation.contacts.forEach(contact => {
            if (contact.signers.length > 0) {
              contact.signers.forEach(signer => {
                if (signer.contactId) {
                  const contact = this.listContacts.find(e => e.id === signer.contactId || ('contactPersons' in e && e.contactPersons.some(cp => cp.id === signer.contactId)))
                  if (contact.id === signer.contactId) {
                    if (signer.email !== contact.email) {
                      this.updateContact(contact, signer.email)
                    }
                  } else if ('contactPersons' in contact && contact.contactPersons.some(cp => cp.id === signer.contactId)) {
                    const contactPerson = contact.contactPersons.find(cp => cp.id === signer.contactId)
                    if (signer.email !== contactPerson.email) {
                      this.updateContact({ ...contactPerson, company: { id: contact.id, name: contact.name } }, signer.email)
                    }
                  }
                }
              })
            }
            // if (element.contactId) {
            //   const contact = this.listContacts.find(e => e.id === element.contactId)
            //   if (element.email !== contact.email) {
            //     this.updateContact(contact, element.email)
            //   }
            // }
          })
        }
        // check if guarantor email updated
        if (this.signatureInvitation.guarantor.length > 0) {
          this.signatureInvitation.guarantor.forEach(element => {
            if (element.contactId) {
              const contact = this.listContacts.find(e => e.id === element.contactId)
              if (element.email !== contact.email) {
                this.updateContact(contact, element.email)
              }
            }
          })
        }
        // get contactId for landlord
        const landLordEmployeeUserIds = this.signatureInvitation.landlord.map(e => e.userId)
        const landLordEmployeeEmails = this.listEmployee.filter(e => landLordEmployeeUserIds.includes(e.id)).map(e => e.email)
        ContactApi.resolveByMail(this.accountId, landLordEmployeeEmails)
          .then(response => {
            let landLord = []
            if (response.persons.length > 0) {
              landLord = landLord.concat(response.persons)
            } else if (response.companies.length > 0) {
              landLord = landLord.concat(response.companies)
            }
            landLord = landLord.filter(e => e.types.includes('EMPLOYEE'))
            // Deduplicate landlords by email (resolveByMail can return multiple entities per email)
            const seenLandlordEmails = new Set()
            landLord = landLord.filter(user => {
              const email = (user.email || '').toLowerCase().trim()
              if (!email || seenLandlordEmails.has(email)) return false
              seenLandlordEmails.add(email)
              return true
            })
            // Build signers with email for deduplication; then send only { contactId, order }
            const signersWithEmail = []
            if (this.signatureInvitation.tenant.length > 0) {
              this.signatureInvitation.tenant.forEach(tenant => {
                if (tenant.signers.length > 0) {
                  tenant.signers.forEach(signer => {
                    if (signer.contactId) {
                      signersWithEmail.push({
                        contactId: signer.contactId,
                        order: 1,
                        email: (signer.email || '').trim()
                      })
                    }
                  })
                }
              })
            } else if (this.signatureInvitation.contacts.length > 0) {
              this.signatureInvitation.contacts.forEach(contact => {
                if (contact.signers.length > 0) {
                  contact.signers.forEach(signer => {
                    if (signer.contactId) {
                      signersWithEmail.push({
                        contactId: signer.contactId,
                        order: 1,
                        email: (signer.email || '').trim()
                      })
                    }
                  })
                }
              })
            }
            if (this.signatureInvitation.guarantor.length > 0) {
              this.signatureInvitation.guarantor.forEach(guarantor => {
                if (guarantor.contactId) {
                  signersWithEmail.push({
                    contactId: guarantor.contactId,
                    order: 1,
                    email: (guarantor.email || '').trim()
                  })
                }
              })
            }
            if (landLord.length > 0) {
              landLord.forEach(user => {
                const email = (user.email || '').trim()
                signersWithEmail.push({
                  contactId: user.id,
                  order: 2,
                  email
                })
              })
            }
            // Deduplicate by email (keep first occurrence; backend allows only one signer per email)
            const seenEmails = new Set()
            const signers = signersWithEmail
              .filter(entry => {
                const key = (entry.email || '').toLowerCase()
                if (!key) return true // no email: keep (cannot deduplicate)
                if (seenEmails.has(key)) return false
                seenEmails.add(key)
                return true
              })
              .map(({ contactId, order }) => ({ contactId, order }))
            // Backend requires unique contactIds (e.g. employee who is also tenant/contact)
            const seenContactIds = new Set()
            const hasDuplicateContactId = signers.some(signer => {
              if (!signer.contactId) return false
              if (seenContactIds.has(signer.contactId)) return true
              seenContactIds.add(signer.contactId)
              return false
            })
            if (hasDuplicateContactId) {
              this.loading = false
              this.uploading = false
              Vue.toasted.show(this.$tc('message.savingErrors.signersHasSameContactIds'), { type: 'error' })
              return
            }
            let attachToRefs = []
            if (this.tenancy) {
              // Always store the canonical tenancy_ prefix so readers can match listTenancies ids.
              const tenancyId = this.tenancy.id || ''
              if (tenancyId) {
                attachToRefs.push(tenancyId.startsWith('tenancy_') ? tenancyId : `tenancy_${tenancyId}`)
              }
            }
            if (this.requestId) {
              attachToRefs.push(this.requestId)
            }
            if (!this.tenancy && this.signatureInvitation.contacts.length > 0) {
              const contactIds = this.signatureInvitation.contacts.map(e => e.contactId).filter(id => id)
              const contactRefs = contactIds.map(id => (!id.toString().startsWith('contact_') ? `contact_${id}` : id))
              attachToRefs = attachToRefs.concat(contactRefs)
            }
            if (!this.tenancy && this.signatureInvitation.tenant.length > 0) {
              // map contactId without duplicates
              const contactIds = [...new Set(this.signatureInvitation.tenant.map(e => e.contactId))].filter(id => id)
              const contactRefs = contactIds.map(id => (!id.toString().startsWith('contact_') ? `contact_${id}` : id))
              attachToRefs = attachToRefs.concat(contactRefs)
            }
            let data = {
              accountId: this.accountId,
              name: this.documentName,
              mediaIds: this.mediasList.map(m => m.id),
              legalWeight: this.signatureInvitation.signType,
              signers: signers,
              note: this.signatureInvitation.note,
              attachToReferenceIds: attachToRefs.filter(ref => ref != null),
              documentType: this.documentType.toUpperCase()
            }
            if (signers.length > 0) {
              DeepSignApi.signDocument(data)
                .then((response) => {
                  this.loading = false
                  this.uploading = false
                  this.$emit('signature-added', response.signRequest)
                  Vue.toasted.show(this.$tc('message.deepSign.messageSuccess'), { type: 'success' })
                  this.hide()
                  this.$nextTick(() => {
                    this.getCountOpenSignRequests()
                  })
                })
                .catch(e => {
                  console.log(e)
                  this.loading = false
                  this.uploading = false
                  let errorMessage = isAxiosError(e) ? e.response?.data?.message : e.message
                  if (errorMessage === 'Could not merge PDFs.') {
                    Vue.toasted.show(this.$tc('message.deepSign.failedToMergePdfs'), { type: 'error' })
                  } else if (errorMessage === 'Error on sign request. Check logs') {
                    Vue.toasted.show(this.$tc('message.deepSign.unknownErrorContactSupport'), { type: 'error' })
                  } else if (errorMessage && typeof errorMessage === 'string' && errorMessage.includes('can only be used at one signer')) {
                    Vue.toasted.show(this.$tc('message.savingErrors.signersHasSameEmails'), { type: 'error' })
                  } else if (errorMessage && typeof errorMessage === 'string' && errorMessage.includes('ContactIds of all signers must be unique')) {
                    Vue.toasted.show(this.$tc('message.savingErrors.signersHasSameContactIds'), { type: 'error' })
                  } else {
                    Vue.toasted.show(errorMessage, { type: 'error' })
                  }
                })
            } else {
              this.loading = false
              this.uploading = false
              Vue.toasted.show(this.$tc('message.savingErrors.mandatoryMissing'), { type: 'error' })
            }
          })
          .catch(e => {
            this.loading = false
            this.uploading = false
            console.log(e)
          })
      }
    },
    cancelSignatureConfirmation() {
      DeepSignApi.cancelRequest(this.signatureRequest.id).then((response) => {
        this.$emit('cancel-signature', this.signatureRequest.id)
        this.hideCancelSignature()
        this.hide()
        this.$nextTick(() => {
          this.getCountOpenSignRequests()
        })
      })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(e.message, { type: 'error' })
        })
    },
    cancelSignature() {
      this.$refs.cancelSignatureModal?.show()
    },
    hideCancelSignature() {
      this.$refs.cancelSignatureModal?.hide()
    },
    isValidSignerEmail(value) {
      const trimmed = (value || '').trim()
      if (!trimmed) {
        return false
      }
      return email(trimmed)
    },
    emailInputState(emailValue, isMandatory) {
      if (this.$v.checkEmails.$dirty && this.$v.checkEmails.$error && this.checkEmails.includes(emailValue)) {
        return false
      }
      if (isMandatory && this.$v.mandatorySignerEmails.$dirty && this.$v.mandatorySignerEmails.$error) {
        return this.isValidSignerEmail(emailValue) ? null : false
      }
      return null
    },
    hasMandatorySignerEmails() {
      if (this.readOnly) {
        return true
      }
      const landlord = this.signatureInvitation.landlord[0]
      if (!landlord || !this.isValidSignerEmail(landlord.email)) {
        return false
      }
      if (this.tenancy) {
        for (const tenant of this.signatureInvitation.tenant) {
          const firstSigner = tenant.signers && tenant.signers[0]
          if (!firstSigner || !this.isValidSignerEmail(firstSigner.email)) {
            return false
          }
        }
      } else {
        for (const contact of this.signatureInvitation.contacts) {
          const firstSigner = contact && contact.signers && contact.signers[0]
          if (!firstSigner || !this.isValidSignerEmail(firstSigner.email)) {
            return false
          }
        }
      }
      return true
    },
    hasDuplicateEmails() {
      let listTenants = []
      let listContacts = []
      this.signatureInvitation.tenant.forEach((tenant) => {
        if (tenant.signers && tenant.signers.length > 0) {
          listTenants = listTenants.concat(tenant.signers.map((signer) => signer))
        }
      })
      this.signatureInvitation.contacts.forEach((contact) => {
        if (contact.signers && contact.signers.length > 0) {
          listContacts = listContacts.concat(contact.signers.map((signer) => signer))
        }
      })
      const contacts = this.signatureInvitation.landlord.concat(listTenants).concat(listContacts).concat(this.signatureInvitation.guarantor)
      const duplicatedEmails = []
      const emailMap = new Map()
      for (const contact of contacts) {
        const email = contact.email.toLowerCase()
        if (emailMap.has(email)) {
          duplicatedEmails.push(email)
        } else {
          emailMap.set(email, true)
        }
      }
      this.checkEmails = duplicatedEmails
    }
  },
  validations() {
    return {
      checkEmails: {
        maxLength: maxLength(0)
      },
      mandatorySignerEmails: {
        valid() {
          return this.hasMandatorySignerEmails()
        }
      },
      documentName: {
        required
      },
      documentType: {
        required
      },
      mediasList: {
        required,
        minLength: minLength(1)
      },
      signatureInvitation: {
        contacts: {
          firstRequired(contacts) {
            if (this.tenancy) {
              return true
            }
            if (!contacts || contacts.length === 0) {
              return false
            }
            return contacts.every(contact => !!(contact && contact.contactId))
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.custom-file-label) {
  height: calc(1.5em + 0.5rem + 2px) !important;
  padding: 0.25rem 0.5rem !important;

  &::after {
    padding: 0.25rem 0.5rem !important;
  }
}

button.primary:focus {
  color: #fff !important;
  background-color: rgb(0, 68, 95) !important;
  border-color: rgb(0, 68, 95) !important;
}

.containerDeleteICon {
  .root {
    width: calc(100% - 30px);
    font-size: 0.825rem;
    display: inline-block;
  }
}

.attachment {
  .custom-file {
    font-size: 0.825rem;
    display: inline-block;
  }
}

.deleteBtn {
  max-width: 30px;
  border: 0;
  box-shadow: none;
  background-color: transparent;
  height: calc(1.5em + 0.3rem);
  display: block;
  align-items: center;
  padding: 0 6px;

  &:hover {
    box-shadow: none !important;
    background-color: transparent !important;
  }
}

:deep(#autosuggest__input) {
  font-size: 0.825rem;
}

.adjustWidthInput {
  max-width: calc(100% - 30px - 0.25rem) !important;
}

.selected {
  color: rgba(0, 0, 0, 0.5);
  background-color: rgba(0, 0, 0, 0.08);
}

:deep(.tooltip) {
  z-index: 10000002 !important;
}

.min-width-btns {
  min-width: 100px;
}
</style>
